import Glider from 'glider-js/glider'; 

export default () => {
    let gliderShop = document.querySelectorAll('.js-carousel-shop'); 
    if(gliderShop){
      gliderShop.forEach(element => {
        let initGliderShop = new Glider(element, {
          slidesToShow: 2.5,
          slidesToScroll: 1.75, 
          draggable: true
        });
        initGliderShop.setOption({
          responsive: [
            { 
              breakpoint: 480,
                settings: {
                  slidesToShow: 2.5,
                  slidesToScroll: 1.75,
                  draggable: true,
                }
            },
            { 
              breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 0,
                  draggable: false,
                }
            }
          ]
        });
        initGliderShop.refresh(true);
      });
    }

  
}